import * as angular from 'angular';

class ConnectionPermissionsController {}

export const ConnectionPermissionsComponent: angular.IComponentOptions = {
  controller: ConnectionPermissionsController,
  controllerAs: 'ctrl',
  bindings: {},
  template: `
    <div class="connection-permissions">
      <div class="tab-header">
        <h3>Connection access</h3>
      </div>

      <div class="tab-body">
        <div ui-view />
      </div>
    </div>
  `,
};
